import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useRealmApp } from "../RealmApp";
import { useMemo } from "react";
import { useDatesContext } from "context/DatesContext";

const useZReports = (storeId, range) => {
  const app = useRealmApp();
  const { zReports, loading } = useAllZReports(
    app.currentUser.id,
    storeId,
    range.start,
    range.end
  );
  return {
    loading,
    zReports,
  };
};

export default useZReports;

function useAllZReports(ownerId, storeId, start, end) {
  const zReportDateInput = {
    storeId,
    start,
    end,
  };
  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl("useAllZReports", 60 * 1000);
  // console.log("fetchPolicy", fetchPolicy);
  //
  const { data, loading, error } = useQuery(
    gql`
      query GetZReportDate($zReportDateInput: ZReportDateInput!) {
        zReportDate(input: $zReportDateInput) {
          _id
          cardAmount
          cardQuantity
          cashAmount
          cashEndAmount
          cashQuantity
          cashStartAmount
          closeDatetime
          closeUserId
          closeUserName
          commissions
          creBase
          creEndNumber
          creQuantity
          creStartNumber
          creTotal
          creationDatetime
          discountAmount
          discountQuantity
          discountRefundAmount
          discountRefundQuantity
          facBase
          facEndNumber
          facQuantity
          facStartNumber
          facTotal
          itemQuantity
          itemRefundQuantity
          mode
          openUserId
          openUserName
          otherAmount
          otherEndAmount
          otherQuantity
          otherStartAmount
          payments
          reportNumber
          status
          storeId
          subcategories
          taxes
          terminalId
          terminalSerial
          type
          updateDatetime
          users
          withdrawals
        }
      }
    `,
    {
      variables: {
        zReportDateInput,
      },
      fetchPolicy,
    }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  let zReports = useMemo(() => data?.zReportDate ?? [], [data]);

  if (!Array.isArray(zReports)) {
    zReports = [zReports];
  }

  const sortedZReports = useMemo(() => {
    return zReports
      .slice()
      .sort((a, b) => new Date(b.updateDatetime) - new Date(a.updateDatetime));
  }, [zReports]);

  return { zReports: sortedZReports, loading };
}
